import * as React from 'react';
import { Providers } from 'Providers';
import { ErrorBoundary } from 'components/ErrorBoundary/ErrorBoundary';
// CSS IMPORTS
import './styles/App.css';
import './styles/font-overrides.css';
import './styles/menu-overrides.css';
import 'flexboxgrid';

import AppToggle from 'AppToggle';

/**
 * Main app component, sets up the router for different pages in the App
 * Includes global error boundary to catch unhandled React errors
 */
const App = () => {
  React.useEffect(() => {
    const apiKey = process.env.REACT_APP_MAP_API;

    // Check if Google Maps script is already loaded
    if (window.google && window.google.maps) {
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=geometry,places&loading=async`;
    script.async = true;

    document.body.appendChild(script);
  }, []);

  return (
    <ErrorBoundary>
      <Providers>
        <AppToggle />
      </Providers>
    </ErrorBoundary>
  );
};

export default App;
